import React, { createContext, useContext, useState } from 'react';

import { Activity } from 'models/Activity';

interface IProductContext {
  selectedSubproduct: Activity | null;
  setSelectedSubproduct: React.Dispatch<React.SetStateAction<Activity | null>>;
  scrollToSubproductAccordion: () => void;
}

const ProductContext = createContext({} as IProductContext);

export const ProductProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [selectedSubproduct, setSelectedSubproduct] = useState<Activity | null>(
    null,
  );

  const scrollToSubproductAccordion = () => {
    window.scrollTo({
      behavior: 'smooth',
      top: 0,
    });
  };

  return (
    <ProductContext.Provider
      value={{
        selectedSubproduct,
        setSelectedSubproduct,
        scrollToSubproductAccordion,
      }}
    >
      {children}
    </ProductContext.Provider>
  );
};

export const useProduct = () => {
  const context = useContext(ProductContext);

  if (!context) {
    throw new Error('useProduct must be used within a ProductProvider');
  }

  return context;
};
